import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './progressBar.css'

import { StoreComponent, injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { MenuButton } from '../../common/elements/buttons'

import posed from 'react-pose'
import bind from 'bind-decorator'

const progressBarProps = {
  open: { opacity: 1, zIndex: 10, transition: { duration: 500, ease: 'easeOut' } },
  closed: { opacity: 0, zIndex: -10, transition: { duration: 500, ease: 'easeIn' } }
}

const AnimatedProgressBar = posed.div(progressBarProps)

interface IProps {
  open: boolean
}

@injectStores
@observer
export class ProgressBar extends StoreComponent<IProps> {

  @bind
  toggleMenu () {
    this.store.storeCommon.menu.open = !this.store.storeCommon.menu.open
  }

  render () {
    const bars = []
    for (const chapter of this.store.storyDocContent.chapters) {
      let isActive: boolean = this.store.storyDocUI.currentSlideIdx === chapter.idx || false
      let barZone: JSX.Element | null = null
      barZone = <div className={styles.barZone}>
                  <div className={classnames(styles.bar, isActive ? styles.active : null)}></div>
                </div>
      bars.push(<Link
                  to={`/story/${chapter.uid}`}
                  key={chapter.id}
                  className={classnames(styles.barItem) }
                >
                  { this.store.breakpoints.desktop ? barZone : this.store.storeCommon.menu.showYellowProgress && barZone }
                  <div className={classnames(styles.text, isActive ? styles.textBold : null, chapter.idx > 0 ? null : styles.introText)}>
                    {chapter.idx > 0 ? `${chapter.idx}  |  ${chapter.title}` : 'Intro'}
                  </div>
                </Link>
                )
    }

    return (
      <AnimatedProgressBar pose={this.props.open ? 'open' : 'closed'} className={styles.progressBar}>
          <div className={styles.burger}>
            <MenuButton onClick={this.toggleMenu} className={styles.menuButton}/>
          </div>
          { this.store.breakpoints.phone ? bars[this.store.storyDocUI.currentSlideIdx] : bars }
        </AnimatedProgressBar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/cover/progressBar.tsx